export default __webpack_public_path__ + "static/media/logo@svg.b0011af3.svg";